import React, { useEffect, useState, useRef } from 'react';
import { Link, useParams } from 'react-router-dom';
import api from '../services/api';
import { getPostCategories } from '../services/PostCategoryService';
import { normalizeImageUrl } from '../utils/imageUtils';

const PromotionCategoryPage = () => {
    const { categoryId } = useParams();
    const [posts, setPosts] = useState([]);
    const [category, setCategory] = useState(null);
    const [loading, setLoading] = useState(true);

    const isFetchingRef = useRef(false);
    const lastFetchedIdRef = useRef(null);

    useEffect(() => {
        const fetchData = async () => {
            if (isFetchingRef.current) return;
            if (lastFetchedIdRef.current === categoryId) return;

            isFetchingRef.current = true;
            setLoading(true);
            try {
                const [allCategories, postsRes] = await Promise.all([
                    getPostCategories(),
                    api.get('/api/posts', { params: { size: 9999 } })
                ]);

                const currentCategory = allCategories.find(
                    c => (c._id || c.id) === categoryId
                );
                setCategory(currentCategory || null);

                let allPosts = [];
                const postsData = postsRes?.data;
                allPosts = Array.isArray(postsData) ? postsData : (postsData?.content || postsData?.items || postsData?.data || []);

                const catName = (currentCategory?.name || '').toLowerCase().trim();

                const filtered = allPosts.filter(p => {
                    const postCat = (p.category || '').toLowerCase().trim();
                    return postCat === catName || p.category === categoryId;
                });
                setPosts(filtered);
                lastFetchedIdRef.current = categoryId;
            } catch (err) {
                console.error('Error fetching promotion category page:', err);
            } finally {
                setLoading(false);
                isFetchingRef.current = false;
            }
        };
        fetchData();
    }, [categoryId]);

    return (
        <main style={{ paddingBottom: 60, borderBottom: '1px solid #ececec' }}>
            {/* ════ MINIMAL BREADCRUMBS ════ */}
            <div className="py-4 mt-[50px]">
                <div className="container px-4 text-left">
                    <nav aria-label="breadcrumb">
                        <ol className="flex items-center gap-2 text-xs md:text-sm uppercase tracking-wider mb-0 p-0 list-none">
                            <li className="breadcrumb-item"><Link to="/" className="hover:text-red-600 transition-colors no-underline text-slate-500">Trang chủ</Link></li>
                            <span className="opacity-30">/</span>
                            <li className="breadcrumb-item"><Link to="/khuyen-mai" className="hover:text-red-600 transition-colors no-underline text-slate-500">Khuyến Mại</Link></li>
                            {category && (
                                <>
                                    <span className="opacity-30">/</span>
                                    <li className="breadcrumb-item active text-slate-900 font-bold" aria-current="page">{category.name}</li>
                                </>
                            )}
                        </ol>
                    </nav>
                </div>
            </div>

            <div className="container">
                <h1 className="heading-primary text-center" style={{ margin: '0 0 32px' }}>
                    <span>{category ? category.name : 'Danh mục khuyến mại'}</span>
                </h1>

                {loading ? (
                    <div className="text-center py-5">
                        <div className="spinner-border text-danger" role="status" />
                        <p className="mt-3 text-muted">Đang tải...</p>
                    </div>
                ) : posts.length === 0 ? (
                    <div className="text-center py-5">
                        <p className="text-muted" style={{ fontSize: 16 }}>Chưa có chương trình khuyến mại nào trong danh mục này.</p>
                        <Link to="/khuyen-mai" style={{ color: '#ff0000', fontWeight: 700 }}>← Xem tất cả khuyến mại</Link>
                    </div>
                ) : (
                    <div className="row g-4">
                        {posts.map(post => (
                            <div key={post._id || post.id} className="col-12 col-md-6 col-lg-4">
                                <div
                                    style={{
                                        background: '#fff', borderRadius: 12, overflow: 'hidden',
                                        boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
                                        transition: 'transform 0.2s, box-shadow 0.2s',
                                        height: '100%', display: 'flex', flexDirection: 'column',
                                    }}
                                    onMouseEnter={e => {
                                        e.currentTarget.style.transform = 'translateY(-4px)';
                                        e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.14)';
                                    }}
                                    onMouseLeave={e => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = '0 2px 12px rgba(0,0,0,0.08)';
                                    }}
                                >
                                    <div style={{ position: 'relative' }}>
                                        <Link to={`/khuyen-mai/${post.slug || post._id || post.id}`} style={{ display: 'block', textDecoration: 'none' }}>
                                            <div style={{ height: 210, overflow: 'hidden', background: '#f5f5f5' }}>
                                                {post.imageUrl ? (
                                                    <img
                                                        src={normalizeImageUrl(post.imageUrl)}
                                                        alt={post.title}
                                                        style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.4s' }}
                                                        onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.05)'}
                                                        onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
                                                    />
                                                ) : (
                                                    <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#ccc', fontSize: 48 }}>🎁</div>
                                                )}
                                            </div>
                                        </Link>
                                        <span style={{
                                            position: 'absolute', top: 12, left: 12,
                                            background: 'linear-gradient(135deg, #ff416c, #ff4b2b)',
                                            color: '#fff', fontSize: 11, fontWeight: 800,
                                            padding: '3px 10px', borderRadius: 999,
                                            boxShadow: '0 2px 8px rgba(255,65,108,0.4)',
                                        }}>
                                            🔥 HOT
                                        </span>
                                    </div>

                                    <div style={{ padding: '12px 18px 18px', flex: 1, display: 'flex', flexDirection: 'column' }}>
                                        <div style={{ fontSize: 12, color: '#aaa', marginBottom: 6 }}>
                                            {post.createdAt ? new Date(post.createdAt).toLocaleDateString('vi-VN') : ''}
                                        </div>
                                        <Link to={`/khuyen-mai/${post.slug || post._id || post.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                                            <h3
                                                style={{
                                                    fontSize: 15, fontWeight: 700, color: '#222', lineHeight: 1.5, marginBottom: 10,
                                                    display: '-webkit-box', WebkitLineClamp: 2,
                                                    WebkitBoxOrient: 'vertical', overflow: 'hidden',
                                                }}
                                                onMouseEnter={e => e.currentTarget.style.color = '#ff0000'}
                                                onMouseLeave={e => e.currentTarget.style.color = '#222'}
                                            >
                                                {post.title}
                                            </h3>
                                        </Link>
                                        {post.description && (
                                            <p style={{ fontSize: 13, color: '#666', lineHeight: 1.6, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', flex: 1 }}>
                                                {post.description}
                                            </p>
                                        )}
                                        <Link
                                            to={`/khuyen-mai/${post.slug || post._id || post.id}`}
                                            style={{
                                                display: 'inline-flex', alignItems: 'center', gap: 6,
                                                marginTop: 14, padding: '8px 18px',
                                                background: '#ff0000', color: '#fff', borderRadius: 8,
                                                fontSize: 13, fontWeight: 700, textDecoration: 'none',
                                                transition: 'background 0.2s', alignSelf: 'flex-start',
                                            }}
                                            onMouseEnter={e => e.currentTarget.style.background = '#e57218'}
                                            onMouseLeave={e => e.currentTarget.style.background = '#ff0000'}
                                        >
                                            Xem chi tiết →
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </main>
    );
};

export default PromotionCategoryPage;



